<template>
    <div class="container">
        <!-- <v-row class="">
      <v-col cols="12" class="top-panel">
        <div class="arrow-btn">
          <img
            src="../assets/img/arrowBack.svg"
            class="img-pluss-btn"
            alt="arrow-back"
          />
        </div>
        <div class="vertical-line-1"></div>
        <div class="add-btn" @click="createItem">
          <img src="../assets/img/plusAdd.svg" alt="pluss" />
          <p class="add-text">Добавить</p>
        </div>
        <div class="vertical-line"></div>
      </v-col>
    </v-row> -->

        <div id="manufacturer">
            <div class="tabs">
                <div class="">
                    <v-toolbar flat id="custom-toolbar" style="height: 100%;">
                        <div class="toolbar-container">
                            <div>
                                <v-toolbar-title class="title">Начисление бонусов
                                </v-toolbar-title>
                            </div>
                            <div class="toolbar-buttons-container">

                                <div class="col-4 restaurant-input">
                                    <div class="">
                                        <v-autocomplete v-model="selectedRestaurant" :items="restaurants"
                                            item-text="restaurant.name" item-value="restaurant.id" outlined
                                            label="Загрузка..." hide-details solo id="restaurant-selector"
                                            placeholder="Выберите ресторан" class="custom-scroll"
                                            @change="onRestaurantChange">
                                            <template v-slot:item="{ item, isSelected }">
                                                <div :class="['restaurant-item', { 'active': isSelected }]">
                                                    {{ item.restaurant.name }} {{ item.restaurant.address ?
                                                        `(${item.restaurant.address})` : '' }}
                                                </div>
                                            </template>
                                        </v-autocomplete>

                                    </div>

                                </div>
                                <div class="buttons-container">
                                    <div>
                                        <button @click="createItem" class="btn-create" style="gap: 5px;">Добавить
                                            гостя<svg width="14" height="14" viewBox="0 0 14 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path
                                                    d="M1.16355 7.88425H5.89505V12.6158C5.89505 13.0967 6.29063 13.5 6.7793 13.5C7.26796 13.5 7.66355 13.0967 7.66355 12.6158V7.88425H12.395C12.876 7.88425 13.2793 7.48866 13.2793 7C13.2793 6.51134 12.876 6.11575 12.395 6.11575H7.66355V1.38425C7.66355 0.903341 7.26796 0.5 6.7793 0.5C6.29063 0.5 5.89505 0.903341 5.89505 1.38425V6.11575H1.16355C0.682638 6.11575 0.279297 6.51134 0.279297 7C0.279297 7.48866 0.682638 7.88425 1.16355 7.88425Z"
                                                    fill="white" />
                                            </svg></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-toolbar>
                </div>
            </div>
            <div v-if="noDataMessage" class="no-data-message">
                <div class="error-container d-flex align-center justify-center">
                    <div class="chart-heading">
                        <p class="error-head">Предупреждение</p>
                        <p class="error-heading">В ресторане {{ this.selectedRestaurantName }} отсутствуют гости, для
                            их добавления нажмите на кнопку ниже.</p>
                        <div class="d-flex align-center justify-center">
                            <button @click="createItem" class="btn-create" style="gap: 5px;">Добавить гостя<svg
                                    width="14" height="14" viewBox="0 0 14 14" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M1.16355 7.88425H5.89505V12.6158C5.89505 13.0967 6.29063 13.5 6.7793 13.5C7.26796 13.5 7.66355 13.0967 7.66355 12.6158V7.88425H12.395C12.876 7.88425 13.2793 7.48866 13.2793 7C13.2793 6.51134 12.876 6.11575 12.395 6.11575H7.66355V1.38425C7.66355 0.903341 7.26796 0.5 6.7793 0.5C6.29063 0.5 5.89505 0.903341 5.89505 1.38425V6.11575H1.16355C0.682638 6.11575 0.279297 6.51134 0.279297 7C0.279297 7.48866 0.682638 7.88425 1.16355 7.88425Z"
                                        fill="white" />
                                </svg></button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else-if="isLoading" class="loading-message d-flex align-center justify-center">
                <v-progress-circular indeterminate size="40" color="primary"></v-progress-circular>
            </div>
            <div v-else>
                <div class="progressive-cashback-container">
                    <v-container class="secondary mt-5">
                        <v-row>
                            <v-col>
                                <!-- @update:options="initialize" :options.sync="options" -->
                                <v-data-table class="guest-grid" :headers="headers" :items="filteredclients"
                                    :search="search" :footer-props="footerProps" :options.sync="options"
                                    :server-items-length="totalItems" hide-default-footer :mobile-breakpoint="0">
                                    <template v-slot:top>

                                        <div class="input-container">
                                            <div class="chart-name-container ">
                                                <p class="table-name">Бонусы в {{ selectedRestaurantName }} ({{
                                                    selectedRestaurantAddress }})</p>
                                            </div>

                                            <div class="search-component">
                                                <input type="search" class="search-component__input" v-model="search"
                                                    ref="searchInput" single-line hide-details
                                                    placeholder="Поиск по номеру телефона" />
                                                <svg width="17" height="17" class="search-component__icon">
                                                    <use href="@/assets/icons/icons.svg#search-icon"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item="{ item }">
                                        <tr>

                                            <td @click="editClient(item)">
                                                {{ item.contact && item.contact.name || "Не указано" }}
                                            </td>
                                            <td @click="editClient(item)">
                                                {{ item.restaurant && item.restaurant.name || 'Не указан' }}
                                            </td>
                                            <td @click="editClient(item)">
                                                {{ item.contact && formatPhoneNumber(item.contact.mobilePhone) ||
                                                    'Отсутствует' }}
                                            </td>
                                            <td @click="editClient(item)">
                                                {{ item.personalDiscountPercent || 'Не указан' }} %
                                            </td>
                                            <td @click="editClient(item)">
                                                {{ item.personalPayWithBonusMaxPercent || 'Не указан' }} %
                                            </td>



                                            <td style="text-align: right">
                                                <v-menu offset-y left transition="scale-transition">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-icon medium v-bind="attrs" v-on="on">
                                                            mdi-dots-vertical
                                                        </v-icon>
                                                    </template>

                                                    <v-list class="menu-list gray-menu">
                                                        <v-list-item @click="editClient(item)">
                                                            <v-list-item-title>Редактировать</v-list-item-title>
                                                        </v-list-item>

                                                        <v-list-item @click="addClientBonus(item)">
                                                            <v-list-item-title>Начислить бонусы</v-list-item-title>
                                                        </v-list-item>


                                                    </v-list>
                                                </v-menu>
                                            </td>

                                        </tr>
                                    </template>
                                    <template v-slot:no-data>
                                        <div v-if="showNoDataMessage">Не найденно подходящих записей.</div>
                                        <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
                                    </template>
                                    <template v-slot:footer>
                                        <div class="v-data-footer">
                                            <div class="v-data-footer__select">
                                                Кол-во строк на странице:
                                                <v-select class="custom-select" v-model="itemsPerPage"
                                                    :items="footerProps.itemsPerPageOptions"
                                                    @change="changeItemsPerPage" hide-details></v-select>
                                            </div>
                                            <div class="v-data-footer__pagination">
                                                {{ (currentPage - 1) * itemsPerPage + 1 }} -
                                                {{ Math.min(currentPage * itemsPerPage, totalItems) }} из
                                                {{ totalItems }}
                                            </div>
                                            <div class="v-data-footer__icons-before">
                                                <button type="button" :disabled="currentPage === 1"
                                                    class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                                                    :class="{ 'v-btn--disabled': currentPage === 1 }"
                                                    aria-label="Предыдущая страница" @click="goToPreviousPage">
                                                    <span class="v-btn__content">
                                                        <i aria-hidden="true"
                                                            class="v-icon notranslate mdi mdi-chevron-left theme--light"></i>
                                                    </span>
                                                </button>
                                            </div>
                                            <div class="v-data-footer__icons-after">
                                                <button type="button" :disabled="currentPage === totalPages"
                                                    class="v-btn v-btn--icon v-btn--round v-btn--text theme--light v-size--default"
                                                    :class="{ 'v-btn--disabled': currentPage === totalPages }"
                                                    aria-label="Следующая страница" @click="goToNextPage">
                                                    <span class="v-btn__content">
                                                        <i aria-hidden="true"
                                                            class="v-icon notranslate mdi mdi-chevron-right theme--light"></i>
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </v-row>
                    </v-container>
                </div>
            </div>
            <v-dialog v-model="dialogCreate" max-width="537px">
                <v-card class="modal-card">
                    <v-card-title class="modal-title">
                        {{ isAddBonusMode ? 'Начисление бонусов' : isBonusMode ? 'Редактирование гостя' :
                            'Добавление гостя' }}
                        <v-spacer></v-spacer>
                        <v-btn icon @click="closeCreate">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <div class="card-item">
                            <div class="card-content-header">
                                <p class="card-content-text">Ресторан {{ selectedRestaurantName }}</p>
                            </div>
                            <div class="horizontal-line mb-4"></div>

                            <!-- Полное имя -->
                            <div class="col-content rest-name-container mb-2">
                                <p class="col-title">Полное имя<span class="red-dot">*</span></p>
                                <input class="input-css" v-model="fullName" placeholder="---"
                                    :readonly="isBonusMode || isAddBonusMode" />
                            </div>

                            <!-- Телефон -->
                            <div class="col-content phonenumber-container mb-2">
                                <p class="col-title">Телефон<span class="red-dot">*</span></p>
                                <input class="input-css" v-model="phone" placeholder="+7(" v-mask="'+7 (###) ###-##-##'"
                                    :readonly="isBonusMode || isAddBonusMode" />
                            </div>

                            <!-- Поля, доступные всегда -->
                            <div class="col-content rest-name-container mb-2">
                                <p class="col-title">Персональная скидка %</p>
                                <input type="number" class="input-css" v-model="personalDiscountPercent"
                                    placeholder="---" :readonly="isAddBonusMode" />
                            </div>

                            <div class="col-content rest-name-container mb-2">
                                <p class="col-title">Максимальный процент оплаты %</p>
                                <input type="number" class="input-css" v-model="personalPayWithBonusMaxPercent"
                                    placeholder="---" :readonly="isAddBonusMode" />
                            </div>


                            <div v-if="isAddBonusMode" class="col-content rest-name-container mb-2">
                                <p class="col-title">Сумма начисления<span class="red-dot">*</span></p>
                                <input type="text" class="input-css" :value="displayAmount" @input="formatAmount"
                                    @keypress="allowOnlyDigits" placeholder="Введите сумму" />
                            </div>



                            <div class="col-content rest-name-container mb-2">
                                <p class="col-title">Ресторан<span class="red-dot">*</span></p>
                                <input class="input-css" :value="selectedRestaurantName" placeholder="---" readonly />
                            </div>
                        </div>
                    </v-card-text>

                    <div class="btn-container">
                        <div class="cancel-btn" @click="closeCreate">Отмена</div>
                        <div class="save-btn" @click="handleButtonClick">
                            {{
                                isAddBonusMode
                                    ? 'Начислить бонусы'
                                    : isBonusMode
                                        ? 'Сохранить изменения'
                                        : 'Сохранить'
                            }}
                        </div>
                    </div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogDelete" max-width="431px">
                <div>
                    <div class="modal-container">
                        <p class="modal-text">Вы точно хотите удалить данного работника?</p>
                        <div class="btn-modal-container">
                            <div class="cancel-btn" text @click="closeDelete">
                                Отмена
                            </div>
                            <div class="del-btn" text @click="editClientConfirm">
                                Удалить
                            </div>
                        </div>
                    </div>

                </div>
                <!-- <v-card>
                      <v-card-title class="text-h5"
                        >Вы точно хотите удалить данного работника?</v-card-title
                      >
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <div class="cancel-btn" text @click="closeDelete">
                          Отмена
                        </div>
                        <div class="del-btn" text @click="editClientConfirm">
                          Удалить
                        </div>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card> -->
            </v-dialog>
            <v-snackbar v-model="snackbar" :timeout="3000" class="btn-contaiener">
                {{ message }}
                <template v-slot:action="{ attrs }">
                    <div class="snackbar-btn" text v-bind="attrs" @click="snackbar = false">
                        Закрыть
                    </div>
                </template>
            </v-snackbar>
        </div>

    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapGetters } from "vuex";
import { debounce } from 'lodash';
export default {
    directives: { mask },
    name: "clients",

    data: () => ({
        options: {
            page: 1, // текущая страница
            itemsPerPage: 10, // количество записей на страницу
            sortBy: [], // параметр сортировки
            sortDesc: [] // направление сортировки (по убыванию)
        },
        displayAmount: "",
        isAddBonusMode: false,
        isBonusMode: false,
        currentClientId: null,
        personalDiscountPercent: null,
        personalPayWithBonusMaxPercent: "",
        isHovered: false,
        isHoveredTogo: false,
        showInputMenu: false,
        // selectedOption: "",
        isPlaceholderHidden: false,
        isfullNameFocused: false,
        isphoneFocused: false,
        selectedRoles: null,
        fullName: "",
        phone: "",
        dialogDelete: false,
        dialogCreate: false,
        search: "",
        snackbar: false,
        message: "",
        roleTranslations: {
            Owner: "Владелец",
            Administrator: "Администратор",
        },
        newClients: {
        },
        employee: {
        },
        selectedType: null,
        rolesTest: [
            { label: "Owner", value: 3 },
            { label: "Administrator", value: 2 },
        ],
        headers: [
            {
                text: "Полное имя",
                align: "start",
                value: "contact.name",
            },
            { text: "Ресторан", value: "restaurant.name" },
            { text: "Телефон", value: "contact.mobilePhone" },
            { text: "Персональная скидка", value: "personalDiscountPercent" },
            { text: "Максимальный процент оплаты", value: "personalPayWithBonusMaxPercent" },
            { text: "Действия", align: "end", value: "actions", sortable: false },
        ],
        clients: [],
        restaurants: [],
        selectedRestaurant: null,
        selectedRestaurantName: "",
        selectedRestaurantAddress: "",
        isLoading: true,
        noDataMessage: false,
        showNoDataMessage: false,
        empRole: "",
        profiles: [],
        error: null,
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        isEditing: false,
        currentEmp: "",
        amount: null,
    }),

    created() {
        this.getAllRestaurants();
        if (this.restaurants.length === 1) {
            this.selectedRestaurant = this.restaurantsList[0].restaurant.id;
        }
        this.getGuestList();
        // this.initialize();
        // this.profileInfo();
    },
    computed: {
        translatedRolesList() {
            return this.rolesTest.map(item => ({
                ...item,
                label: this.roleTranslations[item.label] || item.label
            }));
        },
        filteredclients() {
            // Фильтруем данные внутри таблицы в зависимости от выбранного типа
            if (this.selectedType) {
                console.log(this.selectedType);
                return this.clients.items
                    .filter
                    // (item) => item.rolesTest === this.selectedType
                    ();
            } else {
                return this.clients.items;
            }
        },
        footerProps() {
            return {
                itemsPerPageOptions: [3, 5, 7, 10], // Опции количества элементов на странице
                itemsPerPage: this.itemsPerPage,
                currentPage: this.currentPage,
                totalItems: this.totalItems,
            };
        },
        ...mapGetters({
            user: "user",
        }),
        textareaPlaceholder() {
            return this.isPlaceholderHidden ? "" : "---";
        },
    },

    mounted() {
        window.addEventListener("click", this.handleClickOutside);
        window.addEventListener("click", this.handleClickOutsideTogo);
        if (window.ymaps) {
            ymaps.ready(this.initMap);
        } else {
            console.error("Yandex Maps API не загрузился");
        }
    },
    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutside);
        window.removeEventListener("click", this.handleClickOutsideTogo);
    },

    methods: {
        allowOnlyDigits(e) {
            const char = String.fromCharCode(e.keyCode);
            if (!/[0-9]/.test(char)) {
                e.preventDefault(); // ← Буквы вообще не появятся
            }
        },
        formatAmount(e) {
            let value = e.target.value;

            // убираем пробелы
            let raw = value.replace(/\s/g, "");

            // удаляем всё, кроме цифр
            raw = raw.replace(/\D/g, "");

            if (!raw) {
                this.amount = null;
                this.displayAmount = "";
                return;
            }

            const num = Number(raw);
            this.amount = num;

            this.displayAmount = raw.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        },

        addClientBonus(item) {
            this.currentClientId = item.id;
            this.fullName = item.contact?.name || '';
            this.phone = item.contact?.mobilePhone || '';
            this.selectedRestaurantName = item.restaurant?.name || '';
            this.selectedRestaurant = item.restaurant?.id || '';
            this.personalDiscountPercent = item.personalDiscountPercent || null;
            this.personalPayWithBonusMaxPercent = item.personalPayWithBonusMaxPercent || null;
            this.amount = null;
            this.isAddBonusMode = true;
            this.isBonusMode = false;
            this.dialogCreate = true;
        },

        editClient(item) {
            this.isBonusMode = true; // включаем "режим начисления бонусов"
            this.dialogCreate = true;
            this.isAddBonusMode = false;
            // Заполняем поля из выбранного клиента
            this.fullName = item.contact?.name || '';
            this.phone = item.contact?.mobilePhone || '';
            this.personalDiscountPercent = item.personalDiscountPercent || null;
            this.personalPayWithBonusMaxPercent = item.personalPayWithBonusMaxPercent || null;
            this.selectedRestaurantName = item.restaurant?.name || '';
            this.selectedRestaurant = item.restaurant?.id || '';
            this.currentClientId = item.id; // если нужно потом сохранить изменения
        },
        toNullableNumber(value) {
            return value === '' || value === null || value === undefined || value === '0' || value === 0 ? null : Number(value);        },
        saveBonusChanges() {
            if (!this.currentClientId) {
                this.snackbar = true;
                this.message = "Ошибка: клиент не выбран.";

                return;
            }

            // Проверка обязательных полей
            // if (
            //     this.personalDiscountPercent === '' ||
            //     this.personalPayWithBonusMaxPercent === '' ||
            //     this.personalDiscountPercent === null ||
            //     this.personalPayWithBonusMaxPercent === null
            // ) {
            //     this.snackbar = true;
            //     this.message = "Поля  обязательны для заполнения.";

            //     return;
            // }

            const payload = {
                id: this.currentClientId,
                personalDiscountPercent: this.toNullableNumber(this.personalDiscountPercent),
                personalPayWithBonusMaxPercent: this.toNullableNumber(this.personalPayWithBonusMaxPercent),
            };

            this.$http
                .put(`/api/Client/${this.currentClientId}`, payload, {
                    headers: { "Content-Type": "application/json" },
                })
                .then(() => {
                    this.dialogCreate = false;
                    this.isBonusMode = false;
                    this.initialize(); // обновляем таблицу

                    this.snackbar = true;
                    this.message = "Данные клиента успешно обновлены.";

                })
                .catch((error) => {
                    alert(error);
                    this.snackbar = true;
                    this.message = "Ошибка при обновлении клиента.";

                });
        },





        getRoleTranslation(role) {
            return this.roleTranslations[role] || role;
        },
        getEnglishRoleTranslation(role) {
            for (const key in this.roleTranslations) {
                if (Object.prototype.hasOwnProperty.call(this.roleTranslations, key)) {
                    if (this.roleTranslations[key] === role) {
                        return key;
                    }
                }
            }
            return role;
        },
        hidePlaceholder(inputName) {
            if (inputName === "fullName") {
                this.isfullNameFocused = true;
            }
            // } else if (inputName === "actualAdress") {
            //   this.isActualAdressFocused = true;
            // }
        },

        restorePlaceholder() {
            this.isPlaceholderHidden = false;
            // this.activeTextarea = null;
        },


        closeDialog() {
            this.displayAmount = "";
            this.dialogCreate = false;
            this.fullName = "";
            this.personalDiscountPercent = "";
            this.personalPayWithBonusMaxPercent = "";
            // this.selectedOption = "";
            this.phone = "";
            this.isEditing = false;
        },

        handleButtonClick() {
            if (this.isAddBonusMode) {
                this.addBonusToClient();
            } else if (this.isBonusMode) {
                this.saveBonusChanges();
            } else {
                this.createNewClients();
            }
        },
        addBonusToClient() {
            if (!this.amount || this.amount <= 0) {
                this.snackbar = true;
                this.message = "Введите сумму начисления.";
                return;
            }

            this.$http
                .post(`/api/Client/${this.currentClientId}/bonus`, { amount: this.amount })
                .then((response) => {
                    if (response.status === 204 || response.status === 200) {
                        this.snackbar = true;
                        this.message = "Бонусы успешно начислены!";
                    } else {
                        this.snackbar = true;
                        this.message = "Ответ сервера не содержит данных, но операция прошла успешно.";
                    }
                    this.displayAmount = "";
                    this.dialogCreate = false;
                    this.isAddBonusMode = false;
                    this.isBonusMode = false;
                    this.initialize(); // обновляем таблицу
                })
                .catch((error) => {
                    console.error(error);
                    this.snackbar = true;
                    this.message = "Ошибка начисления бонусов";
                });
        },
        getGuestList() {
            const { page, itemsPerPage, sortBy, sortDesc } = this.options;

            // Сохраняем фокус и позицию курсора
            const el = this.$refs.searchInput;
            const searchWasFocused = !!el && (document.activeElement === el);
            const caretPos = el ? (el.selectionStart || 0) : 0;

            this.isLoading = true;
            this.$http
                .put(`/api/Client/PagedList?restaurantId=${this.selectedRestaurant}`, {
                    pageNumber: this.currentPage,
                    pageSize: this.itemsPerPage,
                    filters: [
                        {
                            property: "Contact.MobilePhone",
                            operator: "contains",
                            value: this.search.replace(/\s+/g, ''),
                        },
                    ],
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    this.clients = {
                        ...response.data,
                        items: response.data.items.filter(item => item.contact !== null)
                    };
                    this.totalPages = response.data.totalPages;

                    // Обновляем totalItems только если оно реально изменилось
                    if (this.totalItems !== response.data.totalCount) {
                        this.totalItems = response.data.totalCount;
                    }

                    if (this.totalItems === 0 && !this.search) {
                        this.noDataMessage = true;
                        this.showNoDataMessage = false;
                    } else if (this.totalItems === 0 && this.search) {
                        this.noDataMessage = false;
                        this.showNoDataMessage = true;
                    } else {
                        this.noDataMessage = false;
                        this.showNoDataMessage = false;
                    }
                })
                .catch((error) => {
                    this.error = error;
                })
                .finally(() => {
                    this.isLoading = false;

                    // Восстанавливаем фокус и позицию курсора
                    this.$nextTick(() => {
                        if (searchWasFocused && this.$refs.searchInput) {
                            const input = this.$refs.searchInput;
                            input.focus();
                            try {
                                input.setSelectionRange(caretPos, caretPos);
                            } catch (e) {
                                // Игнорируем, если браузер не поддерживает
                            }
                        }
                    });
                });
        },
        initialize() {
            this.isLoading = true;
            this.$http
                .put(`/api/Client/PagedList?restaurantId=${this.selectedRestaurant}`, {
                    pageNumber: this.currentPage,
                    pageSize: this.itemsPerPage,
                    // filters: [

                    //     {
                    //         property: "RestaurantId",
                    //         operator: "eq",
                    //         value: this.selectedRestaurant,
                    //     },
                    // ],
                    filters: [
                        {
                            property: "Contact.MobilePhone",
                            operator: "contains",
                            value: this.search.replace(/\s+/g, ''),
                        },
                    ],
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    this.clients = {
                        ...response.data,
                        items: response.data.items.filter(item => item.contact !== null)
                    };
                    this.totalPages = response.data.totalPages;
                    this.totalItems = response.data.totalCount;

                    if (this.totalItems === 0 && !this.search) {
                        this.noDataMessage = true; // показываем блок "В ресторане нет гостей"
                        this.showNoDataMessage = false;
                    }
                    // Если поиск что-то не нашёл → показываем сообщение в таблице
                    else if (this.totalItems === 0 && this.search) {
                        this.noDataMessage = false;
                        this.showNoDataMessage = true; // "Не найдено подходящих записей"
                    }
                    else {
                        this.noDataMessage = false;
                        this.showNoDataMessage = false;
                    }

                    this.isLoading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.isLoading = false;
                });
        },
        goToNextPage() {
            if (this.currentPage < this.totalItems) {
                this.currentPage++;
                this.initialize();
                this.getGuestList();
            }
        },
        goToPreviousPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.initialize();
                this.getGuestList();
            }
        },
        changeItemsPerPage() {
            this.currentPage = 1; // Сбрасываем текущую страницу при изменении количества элементов на странице
            // this.initialize();
            this.getGuestList(); // Вызов метода для загрузки данных с новым количеством элементов на странице
        },
        // editClient(item) {
        //     this.editedIndex = this.clients.items.indexOf(item);
        //     this.editedItem = Object.assign({}, item);
        //     this.dialogCreate = true;
        // },

        editClientConfirm() {
            this.$http
                .delete(`/api/Employee/${this.editedItem.id}`)
                .then(() => {
                    this.clients.items.splice(this.editedIndex, 1);
                    this.initialize();
                    this.closeDelete();

                    // Здесь мы устанавливаем флаг showSnackbar в true,
                    // чтобы уведомление показалось после завершения удаления
                    this.snackbar = true;
                    this.message = "Сотрудник успешно удален"
                })
                .catch((error) => {
                    alert(error);
                    this.snackbar = true;
                    this.message = "Ошибка удаления сотрудника";
                });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        createItem() {
            this.displayAmount = "";
            this.dialogCreate = true;
            this.fullName = "";
            this.isAddBonusMode = false;
            this.phone = "";
            this.personalDiscountPercent = "";
            this.personalPayWithBonusMaxPercent = "";
            this.isEditing = false;
            this.isBonusMode = false; // сбрасываем режим при закрытии

            // this.getEmployee();
        },

        closeCreate() {
            this.displayAmount = "";
            this.dialogCreate = false;
            this.fullName = "";
            this.personalDiscountPercent = "";
            this.personalPayWithBonusMaxPercent = "";
            this.phone = "";
            this.isEditing = false;
            this.isAddBonusMode = false;
            this.isBonusMode = false; // сбрасываем режим при закрытии

        },

        createNewClients() {
            this.newClients.name = this.fullName;
            this.newClients.mobilePhone = this.phone.replace(/[^\d+]/g, '');
            this.newClients.restaurantId = this.selectedRestaurant;

            // ТОЛЬКО это поле
            this.newClients.personalDiscountPercent =
                this.personalDiscountPercent === '' || this.personalDiscountPercent === null
                    ? null
                    : Number(this.personalDiscountPercent);

            this.newClients.personalPayWithBonusMaxPercent =
                this.personalPayWithBonusMaxPercent === '' || this.personalPayWithBonusMaxPercent === null
                    ? null
                    : Number(this.personalPayWithBonusMaxPercent);





            if (!this.fullName || this.fullName.trim() === '') {
                this.snackbar = true;
                this.message = "Имя обязательно для заполнения";
                return;
            }

            if (!this.phone || this.phone.trim() === '') {
                this.snackbar = true;
                this.message = "Телефон обязателен для заполнения";
                return;
            }

            this.$http
                .post("/api/Client", this.newClients)
                .then(() => {
                    this.initialize();
                    this.dialogCreate = false;
                    this.newClients = {
                        restaurantId: "",
                        name: "",
                        mobilePhone: "",
                        personalDiscountPercent: null,
                        personalPayWithBonusMaxPercent: null,
                    };
                    this.snackbar = true;
                    this.message = "Клиент успешно создан";
                })
                .catch(() => {
                    this.snackbar = true;
                    this.message = "Ошибка добавления клиента";
                });
        },
        getAllRestaurants() {
            // let allRest = { restaurantId: null, restaurant: { name: "Все рестораны", id: null } };
            console.log(this.user.roles); // Для отладки

            // Получаем рестораны из ролей пользователя
            this.restaurants = this.user.roles
                .filter(role => role.localPriveleges.includes("ManageDeliveryZones"))
                .filter(role => role.restaurant?.restaurantBonusGroup !== null);

            // Проверяем, если ресторанов больше одного, добавляем "Все рестораны" в начало списка
            if (this.restaurants.length > 0) {
                this.selectedRestaurant = this.restaurants[0].restaurant.id;
                this.selectedRestaurantName = this.restaurants[0].restaurant.name;
                this.selectedRestaurantAddress = this.restaurants[0].restaurant.address;
                // console.log(this.selectedRestaurant);
                this.onRestaurantChange(this.selectedRestaurant);
                console.log(this.selectedRestaurant);
            }

            console.log(this.restaurantsList);
        },
        restList() {
            this.$http
                .put("/api/Restaurant/PagedList", {
                    pageNumber: 1,
                    pageSize: -1,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    //             filters: [
                    //   {
                    //     property: "Name",
                    //     operator: "contains",
                    //     value: this.search.toLowerCase(),
                    //   }
                    // ],
                })
                .then((response) => {
                    this.restaurants = response.data.items.map((item) => ({
                        id: item.id, // Уникальный идентификатор
                        name: item.name || "Не указано",
                        address: item.address || "Не указан",
                    }));
                    if (this.restaurants.length > 0) {
                        this.selectedRestaurant = this.restaurants[0].id;
                        this.selectedRestaurantName = this.restaurants[0].name;
                        this.selectedRestaurantAddress = this.restaurants[0].address;
                        // console.log(this.selectedRestaurant);
                        this.onRestaurantChange(this.selectedRestaurant);
                        console.log(this.selectedRestaurant);
                    }
                    //this.totalPages = response.data.totalPages; // Общее количество страниц
                    // this.totalItems = response.data.totalCount;
                })
                .catch((error) => {
                    this.error = error;
                });
        },
        onRestaurantChange(item) {
            // Здесь вы обновляете название ресторана
            const selectedRestaurantObj = this.restaurants.find(
                r => (r.restaurant?.id ?? r.id) === this.selectedRestaurant
            );

            if (selectedRestaurantObj) {
                this.selectedRestaurantName = selectedRestaurantObj.restaurant?.name ?? selectedRestaurantObj.name ?? "";
                this.selectedRestaurantAddress = selectedRestaurantObj.restaurant?.address ?? selectedRestaurantObj.address ?? "";
            } else {
                this.selectedRestaurantName = "";
                this.selectedRestaurantAddress = "";
            }
            this.currentPage = 1;
            // this.getDashboardInformation();
            // this.initialize();
            this.getGuestList();

        },
        formatPhoneNumber(phoneNumber) {
            if (!phoneNumber) return '';
            const rawPhone = phoneNumber.replace(/\D/g, ''); // Убираем все символы, кроме цифр
            return `+7 ${rawPhone.substring(1, 4)} ${rawPhone.substring(4, 7)} ${rawPhone.substring(7, 9)} ${rawPhone.substring(9, 11)}`;
        },
        formatDate(dateString) {
            if (!dateString) {
                return 'Не указана'; // или любое значение по умолчанию
            }
            const date = new Date(dateString);
            // Форматируем дату в нужный формат (например, "дд.мм")
            return `${String(date.getDate()).padStart(2, '0')}.${String(date.getMonth() + 1).padStart(2, '0')}.${date.getFullYear()}`
        },
        formatName(name) {
            return name || 'Не указано';

        },
        getEmployee(item) {
            this.createItem();
            this.isEditing = true;
            this.editedIndex = this.clients.items.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.currentEmp = item.id;
            this.$http
                .get(
                    `/api/Employee/${item.id}`
                )
                .then((response) => {
                    this.employee = response.data;
                    this.fullName = this.employee.contact.name;
                    // this.empRole = this.getRoleTranslation(this.employee.employeeRole);
                    const foundType = this.rolesTest.find(item => item.label === this.employee.employeeRole);
                    this.empRole = foundType ? foundType.value : null;
                    this.phone = this.employee.contact.mobilePhone;
                })
                .catch((error) => {
                    alert(error);
                });
        },
        editEmployee() {
            this.newClients = {};
            this.newClients.name = this.fullName;
            this.newClients.employeeRole = this.getEnglishRoleTranslation(this.empRole);
            this.$http
                .put(`/api/Employee/${this.currentEmp}`, this.newClients, {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((response) => {
                    this.initialize();
                    this.dialogCreate = false;
                    this.employee = response.data;
                    this.newClients = {
                        name: "",
                        employeeRole: null,
                    };
                    this.snackbar = true;
                    this.message = "Сотрудник успешно изменен";
                })
                .catch((error) => {
                    alert(error);
                    this.snackbar = true;
                    this.message = "Ошибка редактирования сотрудника";
                });
        },
        // editItem(item) {
        //   this.$router.push({ path: `/admin/application/${item.id}` });
        // },
        toggleInputMenu() {
            this.isHovered = false;
            this.showInputMenu = !this.showInputMenu;
        },

        // selectOption(option) {
        //     this.selectedOption = option;
        //     this.toggleInputMenu(); // Вызовите метод для скрытия меню (если это требуется)
        // },

        handleClickOutside(event) {
            const inputButton = this.$refs.inputButton;
            const inputMenu = this.$refs.inputMenu;

            if (
                inputButton &&
                inputMenu &&
                !inputButton.contains(event.target) &&
                !inputMenu.contains(event.target)
            ) {
                this.showInputMenu = false;
            }
        },

        addBorderClass() {
            this.isHovered = true;
        },
        removeBorderClass() {
            this.isHovered = false;
        },
    },

    watch: {
        dialogCreate(val) {
            if (!val) {
                // когда диалог закрыли → очищаем поля
                this.displayAmount = "";
                this.amount = null;
            }
        },

        search: debounce(function () {
            // Выполняем запрос с задержкой после изменения переменной поиска
            this.getGuestList();
        }, 500),

        options: {
            handler(newVal, oldVal) {
                // если сортировка / страница / itemsPerPage изменились → вызываем API
                if (
                    newVal.page !== oldVal.page ||
                    newVal.itemsPerPage !== oldVal.itemsPerPage ||
                    JSON.stringify(newVal.sortBy) !== JSON.stringify(oldVal.sortBy)
                ) {
                    this.getGuestList();
                }
            },
            deep: true
        }

    },
};
</script>

<style scoped>
/* Обычный hover и focus только для НЕ readonly */
.input-css:not([readonly]):hover,
.input-css:not([readonly]):focus,
.input-css-textarea:not([readonly]):hover,
.input-css-textarea:not([readonly]):focus {
    border: 1px solid #d4d4e1;
}

/* Для readonly полей — фиксированный стиль без ховера */
.input-css[readonly],
.input-css-textarea[readonly] {
    cursor: default;
    /* или cursor: not-allowed, если хочешь визуально показать, что поле нельзя редактировать */
    background-color: #f5f5f5;
    /* необязательно, просто для визуала */
    border: 1px solid #e0e0e0;
}

input[type="number"] {
    -moz-appearance: textfield;
    /* Убирает стрелочки в Firefox */
    -webkit-appearance: none;
    /* Убирает стрелочки в Chrome, Safari */
    appearance: none;
    /* Для совместимости */
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    /* Убирает стрелочки в Chrome, Safari */
    margin: 0;
    /* Убирает лишние отступы */
}

.input-container {
    display: flex;
    align-items: center;
    gap: 150px;
    margin-bottom: 10px;
}

.buttons-container {
    display: flex;
    align-items: center;
    gap: 20px;
}

.restaurant-input {
    padding: 12px !important;
    /* width: 100%; */

    min-width: 260px !important;

}

.header-content {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 17px;
}

.no-address-message {
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 167px;
    font-size: 16px;
    color: #333;
    font-family: Inter;
    margin-bottom: 0px;

}

.loyality-container {
    overflow-y: auto;
    overscroll-behavior: none;
    padding-right: 10px
}

.rest-logo {
    margin-right: 11px;
    border-radius: 100px;
    width: 35px;
    height: 35px;
}

.rest-name {
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    color: #333;
    margin-bottom: 0px;
}

.rest-adress {
    font-family: Inter;
    font-weight: 400;
    font-size: 13px;
    color: #98a2b2;
    margin-bottom: 0px;
}

.restaurant-item {

    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    /* Вы можете оставить этот стиль, если он вам нужен */
    line-height: normal;
}

.restaurant-item:first-child {

    /* padding-left: 10px; */
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    /* Вы можете оставить этот стиль, если он вам нужен */
    line-height: normal;
}

.restaurant-item.active {
    font-weight: bold;
    padding-left: 10px;
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-bottom: 1px solid rgb(152, 162, 178);
}

.block.active {
    background: rgba(212, 212, 225, 0.35);
    /* измените на нужный цвет */

    border: 1px solid var(--obvodka);
    /* например, рамка вокруг активного блока */
}

.block:not(.active):hover {
    box-shadow: 0 0 10px 0 rgba(137, 137, 137, 0.25);
    background: white;
}

.error-head {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    text-align: center;
}

.error-heading {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    text-align: center;
}

.guest-grid .v-data-table-header th div {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.cguest-grid .v-data-table-header th div small {
    font-size: 12px;
    color: gray;
}

.guest-grid th {
    white-space: nowrap;
}

.guest-grid th div {
    font-weight: bold;
}

.guest-grid th small {
    display: block;
    font-size: 12px;
    color: grey;
}

.blocks-img {
    width: 14px;
    height: 14px;
}

.block-date {
    font-family: Inter;
    font-weight: 400;
    font-size: 0.78125vw;
    color: #606c80;
    margin-bottom: 0px;
}

.neutral-arrows {
    color: #98a2b2;

}

.percent-text-gray {
    font-family: Inter;
    font-weight: 400;
    font-size: 0.5729vw;
    color: #323c4d;
}

.arrow-color-bot {
    color: red;
    /* width: 16px;
    height: 13px; */
    /* padding-top: 2px; */
}

.arrow-color-top {
    color: green;
    /* width: 16px;
    height: 13px; */
    /* padding-top: 2px; */
}

.percent-status-green {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 15px;
    margin-top: -11px;
    line-height: 1;
    width: 37px;
}

.percent-status {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 15px;
    line-height: 1;
    width: 37px;
}

.percent-text-green {
    color: #00b800;
    font-family: Inter;
    font-weight: 400;
    font-size: 0.572vw;
}

.percent-text-red {
    color: #e41313;
    font-family: Inter;
    font-weight: 400;
    font-size: 0.572vw;
}

.block-title-number {
    font-family: Inter;
    font-weight: 700;
    font-size: 30px;
    color: #323c4d;
    margin-bottom: 0px;
}

.block-numbers {
    display: flex;
    align-items: center;
}

.blocks-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.block-title {
    font-family: Inter;
    font-weight: 400;
    font-size: 1.25vw;
    color: #606c80;
    margin-bottom: 0px;
    text-wrap: nowrap;
}

.blocks-container {
    display: flex;
    /* flex-wrap: wrap; */
    gap: 22px;
    /* Отступ между блоками */
    /* justify-content: center; */
}

.block {
    /* width: 312px;
  height: 136px;
  padding: 11px 18px 8px 20px;
  background-color: white;
  border-radius: 8px;
  cursor: pointer; */
    width: 312px;
    /* height: 136px; */
    padding: 11px 18px 8px 20px;
    background-color: white;
    /* color: white; */
    /* display: flex; */
    border-radius: 8px;
    cursor: pointer;
    width: 100%;
}

::v-deep .v-text-field .v-label--active {
    max-width: 1000%;
    top: 5px !important;
    left: -60px !important;
    font-size: 12px !important;
    font-family: Inter;
    font-weight: 400;
    line-height: 15.73px;
    color: #98a2b2 !important;
}

.custom-text-field ::v-deep .v-label {
    transform: translateY(-10px);
    /* Смещение текста вверх */
    font-size: 29px;
    /* Размер шрифта */
    color: #6b6b6b;
    /* Цвет текста */
}

::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    background: #fff;

}

::v-deep .v-input__prepend-inner {
    margin-top: 8px !important;
}

::v-deep .theme--light.v-sheet {
    background-color: transparent;
    border-color: #ffffff;
    color: rgba(0, 0, 0, 0.87);
}

::v-deep .v-text-field--outlined>.v-input__control>.v-input__slot {
    align-items: stretch;
    min-height: 36px;
    box-shadow: none;
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
}

::v-deep .v-text-field--outlined fieldset {
    border: none !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
    border: 1px solid rgb(224, 224, 224);
}

::v-deep .v-autocomplete.v-input--outlined .v-input__control {
    border: none !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border: none;
}

::v-deep .v-select__slot {
    border: none;
}

::v-deep .v-autocomplete__content.v-menu__content {
    color: #000;
    background-color: #000;
    background: #000;
}

::v-deep .v-autocomplete__content .v-list-item__title {
    color: black;
    /* Цвет текста */
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
    width: 100%;
    border-bottom: 0.5px solid rgb(212, 212, 225);
}

::v-deep .v-text-field.v-text-field--solo .v-input__control {
    min-height: 36px;
    padding: 0;
}


.calendar-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

::v-deep .v-input__prepend-inner {
    margin-top: 8px !important;
}

::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)>.v-input__control>.v-input__slot {
    background: #fff;

}

.custom-text-field ::v-deep .v-label {
    transform: translateY(-10px);
    /* Смещение текста вверх */
    font-size: 29px;
    /* Размер шрифта */
    color: #6b6b6b;
    /* Цвет текста */
}

::v-deep .v-text-field .v-label--active {
    max-width: 1000%;
    top: 5px !important;
    left: -60px !important;
    font-size: 0.9vw;
    font-family: Inter;
    font-weight: 400;
    line-height: 15.73px;
    color: #98a2b2 !important;
}

.error-container {
    max-width: 50%;
    /* Задаем максимальную ширину контейнера */
    margin: 0 auto;
    margin-top: 20px;
    /* margin: 0px 20px; */
    padding: 20px;
    background: #ffffff;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    border-radius: 10px;
}

.btn-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 46px;
    align-items: center;
    margin-right: 20px;
}

.img-exel {
    margin-left: 10px;
}

.btn-exel {
    border-radius: 5px;
    padding: 5px 18px;
    color: white;
    background: #323c4d;
    height: 36px;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.btn-exel-callendar {
    border-radius: 5px !important;
    padding: 5px 18px !important;
    color: white !important;
    background: #323c4d !important;
    height: 36px !important;
    font-family: Inter !important;
    font-weight: 400 !important;
    font-size: 12px !important;
    display: flex !important;
    align-items: center !important;
    text-transform: capitalize !important;

}

.custom-text-field ::v-deep .v-label {
    transform: translateY(-10px);
    /* Смещение текста вверх */
    font-size: 29px;
    /* Размер шрифта */
    color: #6b6b6b;
    /* Цвет текста */
}

.custom-text-field {
    background-color: white;
    margin-bottom: 100px;
    /* Белый фон */
}

.date-picker {
    display: flex;
    flex-direction: row;
    align-items: center;
    align-content: center;
    justify-content: center;
    padding: 12px;
    min-width: 260px;
}

#date-picker-body {
    background: #ffffff;
}

.title {
    font-family: Inter;
    font-weight: 700;
    font-size: 24px !important;
    color: rgb(50, 60, 77);
    margin-right: 10px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.toolbar-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}

.toolbar-buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    width: 100%;

}

.tabs {
    padding: 0 30px 0px 0px;
}

::v-deep .custom-scroll .v-select--is-menu-active::-webkit-scrollbar {
    width: 8px;
    /* Ширина скроллбара */
}

::v-deep .custom-scroll .v-select--is-menu-active::-webkit-scrollbar-thumb {
    background-color: #888;
    /* Цвет ползунка */
    border-radius: 4px;
    /* Радиус скругления ползунка */
}

::v-deep .custom-scroll .v-select--is-menu-active::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    /* Цвет трека */
}

::v-deep .v-autocomplete__content.v-menu__content {
    color: #000;
    background-color: #000;
    background: #000;
}

::v-deep .v-select__slot {
    border: none;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset {
    border: none;
}

::v-deep .v-autocomplete.v-input--outlined .v-input__control {
    border: none !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
    box-shadow: none !important;
    border: 1px solid rgb(224, 224, 224);
}

::v-deep .v-text-field--outlined fieldset {
    border: none !important;
}

::v-deep .v-autocomplete__content.v-menu__content .v-select-list {
    border-radius: 0 0 4px 4px;
    background: green;
}



::v-deep .v-list-item:first-child {
    border-bottom: none;
}

::v-deep .v-list .v-list-item--active {
    color: black;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    /* Толщина, стиль и цвет левой границы */
}

::v-deep .v-autocomplete__content input {
    border: none;
    /* Убираем рамку */
}

::v-deep .v-autocomplete__content .v-list-item__title {
    color: black;
    /* Цвет текста */
}

/* Стили для скрытия рамки при наведении */
::v-deep .v-autocomplete__content .v-list-item:hover {
    border: none;
}

/* Применяем ваши стили к полю ввода */
::v-deep .v-autocomplete__content input {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
    width: 100%;
    outline: unset;
    padding: 0 40px 0 15px;
    display: flex;
    align-items: center;
}

::v-deep .v-menu__content>.v-select__content::-webkit-scrollbar {
    width: 8px;
    /* Ширина скроллбара */
}

::v-deep .v-menu__content>.v-select__content::-webkit-scrollbar-thumb {
    background-color: #888;
    /* Цвет ползунка */
}

::v-deep .v-menu__content>.v-select__content::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    /* Цвет фона скроллбара */
}

::v-deep .v-menu__content {
    max-height: none;
}

::v-deep .v-autocomplete__content>.v-menu__content>.v-select-list {
    color: pink !important;
    background-color: #00b800 !important;
    margin: 100px;
}

#accounts>.container {
    border-radius: 8px;
}

/* Custom styles for the "Закрыть" button */
.custom-snackbar .v-btn--text.v-btn--success {
    color: #fff;
    /* White text color */
}

.custom-snackbar .v-btn--text.v-btn--success:hover {
    background-color: #357a38;
    /* Darker green background on hover */
}

.role-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.border-hover {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    /* Другие стили по вашему усмотрению */
}

.v-col.cols-7 .border-hover {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    background: var(--white, #fff);
}

.profile-menu-item:hover {
    /* Здесь вы можете задать стили для hover-эффекта */
    background-color: #f0f0f0;
    /* Пример: изменение цвета фона при наведении */
    color: #333;
    /* Пример: изменение цвета текста при наведении */
    cursor: pointer;
    /* Пример: изменение курсора при наведении */
    /* Другие стили по вашему усмотрению */
}

.border-input {
    border-radius: 8px;
    border: 1px solid var(--03, #c1c1c1) !important;
    background: var(--white, #fff);
    padding: 6px;
}

.border-white {
    border-radius: 8px;
    border: 1px solid var(--02, white);
    background: var(--white, #fff);
    padding: 6px;
    cursor: pointer;
    width: 100%;
}

.divider-modal {
    background: #e0e0e0;
    height: 1px;
    width: 100%;
    /* Расширяем на всю ширину родительского контейнера */
}

.profile-menu-item {
    color: #000;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    padding-left: 30px;
    padding-top: 11px;
    padding-bottom: 11px;
    width: 100%;
}

.input-menu {
    position: absolute;
    bottom: 32%;
    left: 30.7%;
    width: 347px;
    height: auto;
    border-radius: 10px;
    background: #fff;
    box-shadow: 0px 0px 30px 0px rgba(200, 200, 200, 0.52);
    transition: bottom 0.3s;
    padding: 0px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 100;
    /* right: -15px; */
}

.select-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 35px;
    /* margin-left: 15px; */
}

.option-btn {
    margin-bottom: 0px;
    color: var(--Gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-left: 5px;
}

::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
    box-shadow: none;
}

/* .btn-container {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 46px;
    align-items: center;
    margin-right: 20px;
  } */
.red-dot-margin-2 {
    margin-left: -17px;
}

.red-dot-margin-1 {
    text-align: center;
    margin-left: -17px;
}

.btn-contaiener {
    display: flex;
    justify-content: space-evenly;
}

.cancel-btn {
    color: #eb5757;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    display: inline-flex;
    padding: 13px 29px;
    cursor: pointer;

}

.btn-download {
    display: flex;
    align-items: center;
    gap: 5px;
}

.delete-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    cursor: pointer;
}

.snackbar-btn {
    color: var(--Red, #eb5757);
    font-family: Inter;
    font-size: 0.875rem;
    font-weight: 400;
    letter-spacing: 0.0178571429em;
    line-height: 1.25rem;
    margin-right: auto;
    padding: 14px 16px;
    text-align: initial;
    cursor: pointer;

}

.save-btn {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    background: #323C4D;
    display: inline-flex;
    padding: 13px 29px;
    justify-content: center;
    align-items: center;
    gap: 32.5px;
    cursor: pointer;
}

.del-btn {
    color: #fff;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-radius: 8px;
    background: var(--logo, #b80900);
    display: inline-flex;
    padding: 13px 29px;
    justify-content: center;
    align-items: center;
    gap: 32.5px;
    cursor: pointer;
    margin-left: 30px;
}

.text-limit {
    width: 30ch;
    /* Отображение примерно 10 символов */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    overflow: hidden;
    color: var(--Gray-1, #333);
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-bottom: 0px;
}

.horizontal-line {
    /* Ширина div'а будет равна 100% от родительского контейнера */
    height: 1px;
    /* Толщина линии */
    background: #848484;
    /* Цвет линии (в данном случае черный) */
}

.custom-select {
    position: relative;
    width: 350px;
    cursor: pointer;
    /* margin-left: 9px; */
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
}

.select-arrow {
    position: absolute;
    top: 40%;
    right: 30px;
    /* transform: translateY(-50%); */
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid #333;
    /* Цвет стрелочки */
}

.col-description,
:focus {
    outline: none;
    /* Убираем внешний контур (outline) при фокусе */
    border: none;
    /* Убираем границу (border) при фокусе */
    box-shadow: none;
    /* Убираем тень (box-shadow) при фокусе */
}

.red-dot {
    color: #e41313;
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.col-title {
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    word-wrap: break-word;
    margin-bottom: 10px;
}

.col-paddings-r-l {
    padding-right: 0px;
    padding-left: 0px;
}

.col-content {
    display: flex;
    flex-direction: column;
}

.role-margin {
    margin-right: 37px;
}

.role-margin-1 {
    margin-right: 30px;
}

.col-content-2 {
    display: flex;
    align-items: center;
    width: fit-content;
}

.col-description {
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    /* 146.667% */
    margin-bottom: 0px;
    word-wrap: break-word;
    resize: none;
    height: 30px;
    /* min-height: 20px; */
    width: 100%;
    /* margin-left: 18px; */
}

::v-deep .v-dialog {
    border-radius: 20px;
    background: #f8f8f8;
    margin: 24px;
    overflow-y: auto;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    box-shadow: none;
}

.modal-title {
    color: var(--gray-1, #333);
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
}

.page-title {
    color: var(--gray-1, #333);
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

.vertical-line {
    width: 1px;
    height: 42px;
    background: #e0e0e0;
    margin-left: 31px;
}

.vertical-line-1 {
    width: 1px;
    height: 50px;
    background: #e0e0e0;
}

.add-btn .add-text {
    color: #Fff;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 0px;
    margin-left: 12px;
    margin-right: 12px;
    transition: color 0.3s ease;
}

.add-btn:hover .add-text {
    /* Цвет текста при наведении */
    color: white;
    /* Замените "red" на желаемый цвет текста */
    /* font-weight: 500;
    font-size: 17px; */
}

.add-btn {
    display: flex;
    align-items: center;
    padding: 5px 18px 5px 18px;
    margin-left: 37px;
    cursor: pointer;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    height: 36px;
}

.top-panel {
    /* height: 50px; */
    height: 31px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 14px;
}

.search-container {
    padding-left: 40px;
    padding-right: 30px;
    padding-top: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.img-pluss-btn {
    margin-left: 10px;
}

.arrow-btn {
    /* border-right: 1px solid var(--04, #eaeaea); */
    width: 56px;
    height: 100%;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.search-notfound {
    /* display: flex; */
    margin: 0 auto;
    font-family: "Inter";
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
}

.search-component {
    max-width: 430px;
    width: 100%;
    height: 45px;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
}

.search-component__input {
    border: 1px solid rgb(224, 224, 224);
    border-radius: 5px;
    width: 100%;
    outline: unset;
    padding: 0 40px 0 15px;
    display: flex;
    align-items: center;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
}

.search-component__icon {
    position: absolute;
    top: 14.5px;
    /* right: 55px; */
    right: 12px;
}

#clients-add-button {
    border-radius: 8px;
    background-color: #333;
    color: var(--white, #fff);
    gap: 12px;
    padding: 10px 56px;
    text-align: center;
    font-family: Inter;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    height: 45px;
}

::v-deep .guest-grid tbody tr:nth-child(2n) {
    background: rgba(242, 242, 246, 0.5);
}

::v-deep .v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    color: var(--gray-1, #333) !important;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    text-wrap: nowrap;
}

::v-deep .v-data-table__wrapper>table>thead>tr>th {
    color: #606C80 !important;
    font-family: Inter;
    font-size: 16px !important;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-wrap: nowrap;
}

::v-deep .theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr:last-child>th {
    border-bottom: 2px solid #606C80;
}

.progress-bar {
    width: 100%;
    height: 4px;
    background-color: #98a2b2;
    /* Серый цвет */
    /* border-radius: 10px; */
    overflow: hidden;
}

.progress-bar-fill {
    height: 100%;
    background-color: #323c4d;
    /* Красный цвет заполнения */
    width: 0;
    transition: width 0.3s ease;
}

.card-bonus {
    display: flex;
    align-items: center;
}

.bonus-points {
    font-family: Inter;
    font-size: 30.62px;
    font-weight: 700;
    /* line-height: 37.06px; */
    text-align: left;
    color: #323C4D;
    margin-bottom: 0px;
    margin-right: 5px;
}

.first-order-container {
    margin-top: 10px;
}

.register-container {
    margin-top: 14px;
    margin-bottom: 27px;
}

.birthday-container {
    margin-bottom: 21px;
}

.gender-container {
    margin-bottom: 15px;
}

.phone-container {
    margin-top: 12px;
    margin-bottom: 15px;
}

.small-icons {
    width: 20px;
    height: 20px;
}

.user-column {
    display: flex;
    flex-direction: column;
}

.avatar-container {
    align-items: center;
    display: flex;
    flex-direction: column;
}

#style-3::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
}

#style-3::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #606c80;
}






#style-2::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
}

#style-2::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #606c80;
}

.location-containers {
    margin-bottom: 19px;
    display: flex;
    margin-top: 12px;
    flex-direction: column;


}

.location-container {

    overflow-y: auto;
    overscroll-behavior: none;


}

.location-info {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    color: #606c80;
    margin-bottom: 0px;
}

.location-adress {
    font-family: Inter;
    font-weight: 500;
    font-size: 15px;
    color: #323c4d;
    margin-bottom: 0px;
}

.location-name {
    font-family: Inter;
    font-weight: 700;
    font-size: 15px;
    color: #323c4d;
    margin-bottom: 7px;
}

.third-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 388px;
}

.order-title {
    font-family: Inter;
    font-weight: 600;
    font-size: 16px;
    color: #606c80;
    margin-bottom: 0px;
}

.order-info-text-second {
    font-family: Inter;
    font-weight: 700;
    font-size: 24px;
    /* text-align: right; */
    color: #323c4d;
    margin-bottom: 0px;
}

.order-info-containers {
    display: flex;
    justify-content: space-between;
}

.order-info-containers-1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}

.order-info-text-green {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    color: #00b800;
    margin-bottom: 0px;
    padding: 0 10px;

}

.order-info-container {
    margin-top: 24px;
}

.date-containers {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
}

.date-container-1 {
    max-width: 121px;
    width: 100%;
}

.date-container-2 {
    max-width: 115px;
    width: 100%;
    margin-right: 74px;
}


.date-order {
    font-family: inter;
    font-weight: 700;
    font-size: 15px;
    color: #323c4d;
    margin-bottom: 0px;
}

.order-1 {
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    color: #606c80;
    margin-bottom: 0px;
}

.divider-modal {
    background: #d4d4e1;
    height: 1px;
    width: 100%;
    margin-top: 6.8px;

    /* Расширяем на всю ширину родительского контейнера */
}

.review-img {
    width: 22px;
    padding-right: 5.8px;
}

.review-container {
    display: flex;
    align-items: center;
}

.review-text {

    font-family: Inter;
    font-size: 12px;
    font-weight: 600;
    color: #606c80;

}

.review-title {
    font-family: Inter;
    font-weight: 600;
    font-size: 12px;
    color: #606c80;
    margin-bottom: 0px;
    padding-right: 10px;
}

.title-name {
    font-family: Inter;
    font-weight: 500;
    font-size: 15pxem;
    color: #323c4d;
    margin-bottom: 0px;
    padding-left: 14px;
}

.title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.modal-card {
    background-color: #F8F8F8 !important;
}

.card-username {
    font-family: Inter;
    font-size: 16px;
    font-weight: 700;
    /* line-height: 19.36px; */
    text-align: center;
    margin-bottom: 0px;
    margin-top: 8px;

}

.card-item-second {
    background: #fff;
    max-width: 388px;
    width: 100%;
    border-radius: 5px;
    height: 683px;
    /* height: 100%; */
    display: flex;
    flex-direction: column;
    padding: 15px 13px;

}

.card-item {
    background: #fff;
    /* max-width: 247px; */
    /* width: 388px; */
    border-radius: 5px;
    /* height: 620px; */
    display: flex;
    flex-direction: column;
    padding: 18px 18px 23px 18px;

}

.card-item-3 {
    background: #fff;
    width: 100%;
    max-width: 388px;
    /* height: 35.2777777778vh; */
    display: flex;
    flex-direction: column;
    padding: 10px 13px 21px 15px;
    border-radius: 5px;
}

.card-item-4 {
    background: #fff;
    width: 100%;
    max-width: 388px;
    height: 231px;
    display: flex;
    flex-direction: column;
    padding: 10px 13px 21px 15px;
    border-radius: 5px;
    margin-top: 15px;
}

.card2-title {
    margin: 0;
    font-family: Inter;
    font-size: 15px;
    font-weight: 500;
    line-height: 18.15px;
    text-align: left;

}



.card-cashback {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 16.94px;
    text-align: left;
    color: #98A2B2;
}

.bar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.price-circle {

    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #323C4D;

}

.price-circle-gray {
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background-color: #98A2B2;
}

.price-line-gray {
    background-color: #98A2B2;

    width: 347px;
    height: 2px;
    margin-top: -8px;

}

.price-line-fill {
    width: 260px;
    height: 5px;
    background-color: #323C4D;
    border-radius: 4px;

    margin-top: -4px;
}

.price-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
}

.price-container p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
    color: #98A2B2;
}

.price-remains {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;

    color: #98A2B2;
}



.card-label {
    color: #606C80;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    /* line-height: 2px; */
    text-align: left;
    /* margin-top: 8px; */
    margin-bottom: 5px;

}

.card-text {
    color: #333333;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 18.15px;
    text-align: left;
    margin-bottom: 0px;
}

.card-line {
    background: #d4d4e1;
    height: 1px;
    width: 100%;
    margin-top: 6.8px;
}

.modal-title {
    color: var(--gray-1, #333);
    font-family: Inter !important;
    font-size: 24px !important;
    font-style: normal;
    font-weight: 600 !important;
    line-height: normal;
}

.modal-header {
    padding: 16px 5px 0px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}


::v-deep .v-dialog:not(.v-dialog--fullscreen) {
    max-height: 100%;
}

::v-deep .v-dialog {
    margin: 0px;
}

.cashback-title {
    font-family: Inter;
    font-size: 15px;
    font-weight: 500;
    line-height: 18.15px;
    text-align: left;

    color: #323C4D;
}

.chart-container {
    position: relative;
}

.chart-name-container {
    width: fit-content;
}

.table-name {
    font-family: Inter;
    font-weight: 700;
    font-size: 15px;
    color: #323c4d;
    margin-bottom: 0px;
}

.chart-circle-container {
    position: absolute;
    display: flex;
    flex-direction: column-reverse;

    left: -12.5px;
}

.chart-circle-gray {
    width: 15px;
    height: 15px;
    margin-left: 6px;
    border-radius: 50%;
    background-color: #98A2B2;
}

.chart-circle-container div {
    margin-bottom: 40px;
}

.cashback-line-gray {
    width: 3px;
    height: 280px;
    background-color: #9F9F9F;
}

.cashback-line-fill {
    /* position: relative; */
    /* top: 90px; */
    margin-top: -200px;
    width: 6px;

    margin-left: -1.5px;
    border-radius: 4px;
    background-color: #323C4D;
}

.cashback-prices {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-right: 15px;
    width: 50%;
}

.cashback-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-right: 10px;
}

.cashback-info div {
    display: flex;
    align-items: center;
    margin-bottom: 60px;
    margin-left: 12.5px;
}

.cashback-info h4 {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 19.36px;
    margin-left: 5px;
}

.cashback-info p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    line-height: 14.52px;
    text-align: left;
    margin: 0;
    margin-left: 5px;

    color: #606C80;
}

.cashback-prices p {
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    /* line-height: 0px; */
    text-align: left;
    margin-bottom: 72.5px;

    /* margin: 0; */
    color: #606C80;
}

#custom-toolbar ::v-deep .v-toolbar__content {
    padding-left: 0 !important;
    /* Убирает отступ слева */
}

.btn-create {
    /* width: 121px; */
    height: 36px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 5px 18px;
    border-radius: 5px;
    background: rgb(50, 60, 77);
    color: white;

}

.input-css {
    border-radius: 5px;
    padding: 10px 10px 10px 10px;
    /* height: 42px; */
    border: 1px solid transparent;
    outline: none;
    transition: border 0.3s ease;
    font-family: Inter;
    font-weight: 600;
    font-size: 15px;
    color: #323c4d;
}

.card-content-text {
    font-family: Inter;
    font-size: 20px;
    font-weight: 700;
    line-height: 24.2px;
    text-align: left;
    color: #323C4D;
    margin-bottom: 8px;
}

.gray-menu {
    background: #ffffff !important;
    /* светло-серый */
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 4px 0;
}

.btn-modal-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 36.7px;
}

.modal-text {
    font-family: Inter;
    font-weight: 700;
    font-size: 24px;
    text-align: center;
    color: #323c4d;
    margin-bottom: 0px;
    line-height: normal;
}

.modal-container {
    padding: 20px 20px 37px 20px;
}

@media screen and (max-width:980px) {

    /* .buttons-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    margin-bottom: 10px;
  } */

    .restaurant-input {
        padding: 12px 0 12px 0 !important;
        width: 100%;
    }

    .date-picker {
        padding: 12px 0 12px 0 !important;
    }

    .toolbar-buttons-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .title {
        font-size: 18px !important;
        justify-content: flex-start;
        align-items: flex-start;
    }

    ::v-deep .v-label--active {
        font-size: 16px !important;
        left: 0px !important;
        margin-left: 25px;
        line-height: 15.73px;
        color: #98a2b2 !important;
    }

    .toolbar-container {
        flex-direction: column;
        height: 100%;
    }

    #custom-toolbar ::v-deep .v-toolbar__content {
        height: 100% !important;
    }
}

@media screen and (max-width:700px) {
    .error-container {
        max-width: 100%;


    }

    .buttons-container {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;

        margin-bottom: 10px;
    }

    .restaurant-input {
        padding: 12px 0 12px 0 !important;
        width: 100%;
    }

    .date-picker {
        padding: 12px 0 12px 0 !important;
    }

    .blocks-img {
        width: 12px;
        /* height: 2.68518518519vh; */
    }

    .percent-text-gray {
        font-size: 10px;

    }

    .percent-text-green {
        font-size: 10px;
    }

    .percent-text-red {

        font-size: 10px;
    }

    .block-title {
        font-size: 15px;
    }

    .block-title-number {
        font-size: 12px;
    }

    .block-date {
        font-size: 10px;
        margin-top: 5px;
    }

    .toolbar-buttons-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        height: 100%;
    }

    .title {
        font-size: 18px !important;
        justify-content: flex-start;
        align-items: flex-start;
    }

    ::v-deep .v-label--active {
        font-size: 16px !important;
        left: 0px !important;
        margin-left: 25px;
        line-height: 15.73px;
        color: #98a2b2 !important;
    }

    .toolbar-container {
        flex-direction: column;
        height: 100%;
    }

    .btn-exel {
        font-size: 12px;
        display: flex;
        align-items: center;
    }



    .search-buttons-container {
        flex-direction: column;
    }

    #custom-toolbar ::v-deep .v-toolbar__content {
        height: 100% !important;
    }

    .blocks-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        /* flex-wrap: wrap; */
        gap: 22px;
        /* Отступ между блоками */
        /* justify-content: center; */
    }
}

@media (min-width: 1264px) {
    .container {
        max-width: 100% !important;
    }
}

@media (min-width: 960px) {
    .container {
        max-width: 100% !important;
    }
}

@media (max-width: 1600px) {
    .block {
        width: calc(50% - 11px);
        /* 50% ширины с учётом gap */
    }
}

@media (max-width: 1146px) {
    .block {
        width: calc(19.5% - 11px);
        /* 50% ширины с учётом gap */
    }

    .block-title {
        font-size: 1.1vw;
    }
}

@media (max-width: 768px) {
    .block {
        width: 100%;
        /* Полная ширина на мобильных устройствах */
    }

    .input-container {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 10px;
        flex-direction: column;
    }
}

::v-deep .v-menu__content.v-select__content::-webkit-scrollbar {
    width: 8px;
    /* Ширина скроллбара */
}

::v-deep .v-menu__content.v-select__content::-webkit-scrollbar-thumb {
    background-color: #888;
    /* Цвет ползунка */
}

::v-deep .v-menu__content.v-select__content::-webkit-scrollbar-track {
    background-color: #f1f1f1;
    /* Цвет фона скроллбара */
}

::v-deep .v-menu__content.theme--light.menuable__content__active.v-autocomplete__content {
    color: pink !important;
    background-color: #00b800 !important;
}

::v-deep .v-autocomplete__content {
    background-color: black;
    /* Устанавливаем черный цвет для фона меню */
    color: white;
    /* Устанавливаем белый цвет для текста в меню */
}
</style>
